var MyApp = {
    bannerEvo: function(){

        $('.banner-hero .modal').modal();

        $('.banner-hero .modal .btn--primary').on('click', function(){
            $self = $(this).parent().parent();
            
            $('.formulario .input--field-check input').prop('checked', true);
            $self.modal('close');   
        });
                
        var prefix = '.slider .slider__item:not(.slick-cloned) ';
        var ctrlDoc = $(prefix + 'input[name=gqcw_doc]');
        var ctrlDocError = $(prefix + '#gqcw_doc_error');
        var ctrlMovil = $(prefix + 'input[name=gqcw_movil]');
        var ctrlMovilError = $(prefix + '#gqcw_movil_error');
        var ctrlHour = $(prefix + 'select[name=gqcw_hour]');   

        ctrlMovil.on("input", function(){
            this.value = this.value.replace(/[^0-9]/g,'');
        });
        ctrlMovil.on("focus", function(){
            $(this).removeClass('alert--danger');
            ctrlMovilError.addClass('hide');
        });
        ctrlMovilError.on("click", function(){
            ctrlMovil.removeClass('alert--danger');
            $(this).addClass('hide');
        });
    
        ctrlMovil.on("keypress", function(e) {
            var numTotal = this.value.length;
            key = e.keyCode || e.which;
            if (numTotal == 0) {
                var tecla = String.fromCharCode(key);
                var caracteres = "9";
                var especiales = [8, 9, 37, 39, 46, 6];
                var tecla_especial = false;
                for (var i in especiales) {
                    if (key == especiales[i]) {
                        tecla_especial = true;
                        break;
                    }
                }
                if (caracteres.indexOf(tecla) == -1 && !tecla_especial) {
                    return false;
                }
            }
            return (key > 47 && key < 58);
        });

        ctrlDoc.on("input", function(){
            this.value = this.value.replace(/[^0-9]/g,'');
        });
        ctrlDoc.on("focus", function(){
            $(this).removeClass('alert--danger');
            ctrlDocError.addClass('hide');
        });
        ctrlDocError.on("click", function(){
            ctrlDoc.removeClass('alert--danger');
            $(this).addClass('hide');
        });
        
        ctrlHour.on("focus", function(){
            $(this).removeClass('alert--danger');
        });

        //variables de transicion
        var current_fs, next_fs;
        var left, opacity, scale;
        var animating;

        //envio de formulario
        $(prefix + ".formulario").submit(function(e){
            e.preventDefault();
            var ctrlDoc = $(prefix + 'input[name=gqcw_doc]');
            var ctrlDocError = $(prefix + '#gqcw_doc_error');
            var ctrlMovil = $(prefix + 'input[name=gqcw_movil]');
            var ctrlMovilError = $(prefix + '#gqcw_movil_error');
            var contForm = $(prefix + '#gqcw_cont');
            var ctrlHour = $(prefix + 'select[name=gqcw_hour]');
            var error = false;
            if(ctrlDoc.val().length === 0){
                error = true;
                ctrlDoc.addClass('alert--danger');
                ctrlDocError.removeClass('hide');
            }else if((ctrlDoc.val().length !== 8 && ctrlDoc.val().length !== 11) || !jQuery.isNumeric(ctrlDoc.val())){
                error = true;
                ctrlDoc.addClass('alert--danger');
                ctrlDocError.removeClass('hide');
            }else{
                ctrlDoc.removeClass('alert--danger');
                ctrlDocError.addClass('hide');
            }
            
            if(ctrlMovil.val().length === 0){
                error = true;
                ctrlMovil.addClass('alert--danger');
                ctrlMovilError.removeClass('hide');
            }else if(ctrlMovil.val().length !== 9 || !jQuery.isNumeric(ctrlMovil.val())){
                error = true;
                ctrlMovil.addClass('alert--danger');
                ctrlMovilError.removeClass('hide');
            }else{
                ctrlMovil.removeClass('alert--danger');
                ctrlMovilError.addClass('hide');
            }
            
            if(contForm.hasClass('container__formulario--full') && ctrlHour.val() === null){
                error = true;
                ctrlHour.addClass('alert--danger');
            }else{
                ctrlHour.removeClass('alert--danger');
            }
            if(!error){
                // dataLayer.push({'event':'atm-c2c','codProducto':'1-26-1-2-1-280-243-1-1','nombreProducto':'Movistar Chip Mi Movistar|NEGRO|Residencial|Portabilidad|Normal|Plan Ilimitado Mi Movistar S/65.90','precio':''});

                //variables preloading button
                var bar = $(prefix + '.progress-inner');
                var button = $(prefix + '.progress-button');

                //removiendo clases al preloading button
                bar.removeClass('notransition');
                button.addClass('state-loading');

                //variables e intervalo de carga
                var progress = 0,
                    interval = setInterval( function() {
                    progress = Math.min( progress + Math.random() * 0.1, 1 );
                    bar.css({
                        'width': (progress*100) + '%',
                        'opacity': 1
                    });

                    //deshabilitando inputs
                    $(prefix + '.input--field-control').attr('disabled', true);
                    $(prefix + '.input--field-check input').attr('disabled', true);
                    $(prefix + '.input--field-check span a').css('pointer-events','none');
                    
                    //validando el progreso de carga
                    if( progress === 1 ) {
                        //finalizando animacion de carga
                        button.removeClass('state-loading');
                        button.addClass('state-success');
                        bar.addClass('notransition');
                        bar.css({
                            'width': 0,
                            'opacity': 1
                        });
                        //cerrando intervalo
                        clearInterval( interval );

                        //limpiando campos
                        $(prefix + '.input--field-control').val('');
                        
                        setTimeout(function(){
                            //Animation Mensaje
                            if (animating) return false;
                            animating = true;
                            current_fs = $(prefix + '.formulario');
                            next_fs = $(prefix + '.container__message');
                            next_fs.show();
                            current_fs.animate({ opacity: 0 }, {
                                step: function (now, mx) {
                                    scale = 1 - (1 - now) * 0.2;
                                    left = (now * 50) + "%";
                                    opacity = 1 - now;
                                    current_fs.css({
                                        'transform': 'scale(' + scale + ')',
                                        'position': 'absolute'
                                    });
                                    next_fs.css({ 'left': left, 'opacity': opacity });
                                },
                                duration: 800,
                                complete: function () {
                                    current_fs.hide();
                                    animating = false;                                
                                },
                                //tipo de animacion
                                easing: 'easeInOutBack'
                            });

                            //habilitando campos
                            $(prefix + '.input--field-control').removeAttr('disabled');
                            $(prefix + '.input--field-check input').removeAttr('disabled');
                            $(prefix + '.input--field-check span a').removeAttr('style');
                            button.removeClass('state-success');
                        }, 1000)

                        // Colocar este script de acuerdo a la validacion de error del servidor
                        // para retornar al fomulario
                        $(prefix + '#returnForm').on('click', function(){
                            if (animating) return false;
                            animating = true;
                        
                            current_fs = $(prefix + '.container__message');
                            previous_fs = $(prefix + '.formulario');                        
                        
                            //show the previous fieldset
                            previous_fs.show();
                            //hide the current fieldset with style
                            current_fs.animate({
                              opacity: 0
                            }, {
                              step: function(now, mx) {
                                //as the opacity of current_fs reduces to 0 - stored in "now"
                                //1. scale previous_fs from 80% to 100%
                                scale = 0.8 + (1 - now) * 0.2;
                                //2. take current_fs to the right(50%) - from 0%
                                left = ((1 - now) * 50) + "%";
                                //3. increase opacity of previous_fs to 1 as it moves in
                                opacity = 1 - now;
                                current_fs.css({
                                  'left': left
                                });
                                previous_fs.css({
                                  'transform': 'scale(' + scale + ')',
                                  'opacity': opacity
                                });
                              },
                              duration: 800,
                              complete: function() {
                                current_fs.hide();
                                animating = false;
                              },
                              //this comes from the custom easing plugin
                              easing: 'easeInOutBack'
                            });
                        });
                    }
                }, 200);                                
            }
        });
    
    },
    bannerEvo2: function(){

        if($('.nat-bannerEvo .slider__item').length > 1){
            var swiper = new Swiper('.nat-bannerEvo .swiper-container', {
                loop: true,
                loopFillGroupWithBlank: true,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: true,
                },
                keyboard: {
                    enabled: true,
                },
                pagination: {
                  el: '.swiper-pagination',
                  clickable: true,
                  dynamicBullets: true,
                }
            });

            $(".nat-bannerEvo .swiper-container").on('mouseover', function() {
                (this).swiper.autoplay.stop();
            });
            
            $(".nat-bannerEvo .swiper-container").on('mouseout', function() {
                (this).swiper.autoplay.start();
            });
        }

        $(".nat-bannerEvo .slider__anchor .anchor").click(function(evento){
            evento.preventDefault();
            var codigo = $(this).attr("href");
            $("html,body").animate({scrollTop: $(codigo).offset().top}, 500);
        });    
    },
    carruselPlanes: function(){

        $('.plan__footer .btn-flat').bind('click', function(){
            $('.plan__item').toggleClass('item--open');
            $('.benefit__list--compress').slideToggle();
            $('.benefit__list--complete').slideToggle();
        });
        
        $('.plans .plans__list').slick({        
            slidesToShow: 4,
            slidesToScroll: 1,
            dots: false,
            arrows: true,
            responsive: [
                {
                  breakpoint: 1350,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,                
                        dots: false,
                    }
                },
                {
                  breakpoint: 1199,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        dots: true,
                        arrows: false
                    }
                },
                {
                  breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        dots: true,
                        arrows: false
                    }
                },
                {
                  breakpoint: 650,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: true,
                        arrows: false
                    }
                }
                
            ]
        })
    
    },
    contactanos: function(){

        //Select materialize
        var $select = $('.contact__modal select');
        $select.material_select();

        //Funcion de intervalo de hora para el campo select
        function verifyHourDisplay(){
            var hourEnableData = '22:00'; //'22:00'
            var hourDisabledData = '06:00'; //'06:00'
            var hourEnableArray = hourEnableData.split(':');
            var hourDisabledArray = hourDisabledData.split(':');
            var hourEnable = parseInt(hourEnableArray[0]);
            var minuteEnable = parseInt(hourEnableArray[1]);
            var hourDisabled = parseInt(hourDisabledArray[0]);
            var minuteDisabled = parseInt(hourDisabledArray[1]);

            if((hourEnable + minuteEnable) > 0 && (hourDisabled + minuteDisabled) > 0){

                var dateNowBn = new Date();
                var isShow = true;
                if(dateNowBn.getHours() <= hourEnable && dateNowBn.getHours() >= hourDisabled){
                    if(dateNowBn.getHours() == hourEnable || dateNowBn.getHours() == hourDisabled){
                        if((dateNowBn.getHours() == hourEnable && dateNowBn.getMinutes() < minuteEnable) || (dateNowBn.getHours() == hourDisabled && dateNowBn.getMinutes() >= minuteDisabled)){
                            isShow = false;
                        }
                    }else{                        
                        isShow = false;
                    }                    
                }
                
                if(isShow){
                    $('#hour').parent().parent().removeClass('disabled');
                    active();
                }else{
                    var $select = $('#hour')
                    $select.prop('selectedIndex', 0);
                    $select.material_select();
                    active();
                    $('#hour').parent().parent().addClass('disabled');
                }
            }
        }
        verifyHourDisplay();
        setInterval(verifyHourDisplay, 500);
        
        //casos drop down Select
        $(".field__select input[type=text]").blur(function(){
            $('.icon-drop_down').removeClass('active');
        })
        $(".field__select input[type=text]").on('click', function(){
            if($(this).hasClass('active')){
                $('.icon-drop_down').addClass('active');
            }else{
                $('.icon-drop_down').removeClass('active');
            }
        })
        $(".field__select .dropdown-content li").on('click', function(){
            $('.icon-drop_down').removeClass('active');
        });
        $('#termsCondition').on('click', function(){
            $('.field__checkbox').prop("checked", true);
        });

        //Select textos de horario para el modal
        $('#hour').on('change', function(e){
            var $value = $('.dropdown-content li.active').text();
            $('.description--hour').text($value);
        });

        //modales
        $('#formContact').modal({
            dismissible: false,
            ending_top: '10%',    
        });
        $('#movil').modal({
            dismissible: false,
            ending_top: '10%',         
        });
        $('#message').modal({
            dismissible: false,
            complete: function(modal, trigger) {
                $('#message >.container').addClass('hide');
            }
        });
                                                      
        $('#protectClause').modal({
            dismissible: false,
            ready: function(modal, trigger) { // Callback for Modal open. Modal and trigger parameters available.                
                //Scroll content Terminos y condiciones 
                var swiperScroll = new Swiper('#protectClause .swiper-container', {
                    direction: 'vertical',
                    slidesPerView: 'auto',
                    freeMode: true,
                    scrollbar: {
                        el: '.swiper-scrollbar',
                        dragSize: '35px',
                        draggable: true,
                        snapOnRelease: false,
                    },
                    mousewheel: true,
                }); 
            },
        })

        //Especificaiones de campo
        var $document = $('.contact__modal  #document');
        var $phone = $('.contact__modal  #phone');      

        $phone.on("keypress", function(e) {
            var numTotal = this.value.length;
            key = e.keyCode || e.which;
            if (numTotal == 0) {
                var tecla = String.fromCharCode(key);
                var caracteres = "9";
                var especiales = [8, 9, 37, 39, 46, 6];
                var tecla_especial = false;
                for (var i in especiales) {
                    if (key == especiales[i]) {
                        tecla_especial = true;
                        break;
                    }
                }
                if (caracteres.indexOf(tecla) == -1 && !tecla_especial) {
                    return false;
                }
            }
            return (key > 47 && key < 58);
        });

        $document.on('input', function () { 
            this.value = this.value.replace(/[^0-9]/g,'');
        });
        
        //Titulos modal form
        $('.contact__item').on('click', function(){
            var text = $(this).find('.container .description').text();
            var replaceText = text.toLowerCase().split(" ").join("-");
            var resetText = replaceText.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
            $('.contact__modal .modal__title strong').text(text);
            $('#formContact').attr('data-modal',resetText);
        });

        //Atributos modales movil
        $('#movil .modal__btn').on('click', function(){
            var text = $(this).text();
            var replaceText = text.toLowerCase().split(" ").join("-");
            var resetText = replaceText.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
            $('#formContact').attr('data-modal',resetText);
        });        

        //Valid and enabled button
        $('.field__btn').attr('disabled', true);

        //funciones de validacion de campos
        function doctype(){
            $('#document').on('keyup', function(){
                var option = 1;
                $(this).parent().removeClass('field__invalid');
                if($(this).val().length < 8){
                    option = 0;
                    $(this).parent().addClass('field__invalid');
                }
                setTimeout(function(){
                    active(1,option);
                },5)
            });
        }
        function phone(){
            $('#phone').bind('keyup', function(){
                var option = 1;
                $(this).parent().removeClass('field__invalid');
                if($(this).val().length < 9){
                    option = 0;
                    $(this).parent().addClass('field__invalid');
                }                
                setTimeout(function(){
                    active(2,option);
                },5)
            });
        }
        function hour(){
            $('#hour').on('change', function(e){
                var select = e.target.value;
                var option = 1;
                $(this).parent().removeClass('field__invalid');
                if(select == 0){
                    option = 0;
                    $(this).parent().addClass('field__invalid');
                }
                setTimeout(function(){
                    active(3,option);
                },5)
            });
        }
        function terms(){
            $('#treatment, #termsCondition').on('click', function(){
                var option = 1
                if($(this).prop("checked") == false){
                    option = 0;
                }
                setTimeout(function(){
                    active(4,option);
                },5)
            });
        }           

        //contabilizando las validaciones
        var count = 0, ndocument = 0, nphone = 0, nhours = 0, nterms = 0;
        function active(status,option){
            if( status === 1) { ndocument = option }
            if( status === 2) { nphone = option }
            if( status === 3) { nhours = option }
            if( status === 4) { nterms = option }

            //casos de contabilizacion de validaciones
            if($('#treatment').hasClass('required')){
                if($('.field__group').hasClass("disabled")){
                    count = parseInt(ndocument) + parseInt(nphone) + parseInt(nterms);
                    if(count === 3){
                        $('.field__btn').attr('disabled',false);
                    }else{
                        $('.field__btn').attr('disabled',true);
                    }                
                }else{
                    count = parseInt(ndocument) + parseInt(nphone) + parseInt(nhours) + parseInt(nterms);
                    if(count === 4){
                        $('.field__btn').attr('disabled',false);
                    }else{
                        $('.field__btn').attr('disabled',true);
                    }
                }
            }else{
                if($('.field__group').hasClass("disabled")){
                    count = parseInt(ndocument) + parseInt(nphone);
                    if(count === 2){
                        $('.field__btn').attr('disabled',false);
                    }else{
                        $('.field__btn').attr('disabled',true);
                    }                
                }else{
                    count = parseInt(ndocument) + parseInt(nphone) + parseInt(nhours);
                    if(count === 3){
                        $('.field__btn').attr('disabled',false);
                    }else{
                        $('.field__btn').attr('disabled',true);
                    }
                }
            }                        
        }        
        
        //Envio de Formulario
        $( ".contact__modal form" ).on('submit', function( event ) {
            event.preventDefault();
            
            //reseteando variables de funciones y deshabilitando el boton
            $('.field__btn').attr('disabled', true);
            count = 0;
            ndocument = 0;
            nphone = 0;
            nhours = 0;
            nterms = 0;

            //variables preloading button
            var bar = $('.progress-inner');
            var button = $('.progress-button');

            //removiendo clases al preloading button
            bar.removeClass('notransition');
            button.addClass('state-loading'); 
            
            //variables e intervalo de carga
            var progress = 0,
                interval = setInterval( function() {
                progress = Math.min( progress + Math.random() * 0.1, 1 );
                bar.css({
                    'width': (progress*100) + '%',
                    'opacity': 1
                });

                //deshabilitando campos
                $('.field__input').attr('disabled', true);
                $('.field__checkbox').attr('disabled', true);
                $('.select-dropdown').attr('disabled', true);
                $('.modal-action.modal-close').attr('disabled', true);
                $('.modal__footer .link').attr('disabled', true);

                //validando el progreso de carga
                if( progress === 1 ) {
                    //finalizando animacion de carga
                    button.removeClass('state-loading');
                    button.addClass('state-success');
                    bar.addClass('notransition');
                    bar.css({
                        'width': 0,
                        'opacity': 1
                    });
                    //cerrando intervalo
                    clearInterval( interval );
                    
                    //Limpieza de campos
                    $('#document').val('');
                    $('#phone').val('');
                    var $select = $('#hour').prop('selectedIndex', 0);
                    $select.material_select();
                    $('#treatment').prop('checked', false);                        

                    //habilitando campos
                    $('.field__input').removeAttr('disabled');
                    $('.field__checkbox').removeAttr('disabled');
                    $('.select-dropdown').removeAttr('disabled');
                    $('.modal-action.modal-close').removeAttr('disabled');
                    $('.modal__footer .link').removeAttr('disabled');

                    //mensaje final de la operacion
                    setTimeout(function(){
                        button.removeClass('state-success');
                        //Evento Close modal
                        $('#formContact').modal('close');
                        //Evento open modal
                        $('#message').modal('open');
                        if($('.field__group').hasClass("disabled")){
                            $('.message--2').removeClass('hide');
                        }else{
                            $('.message--3').removeClass('hide');
                        }                        
                    },1000)
                }
            }, 200 );
        }); 

        doctype();
        phone();
        hour();
        terms();
        active();
    },

    servicio: function(){                    
        
        $('.service__list').each(function(){
            var listSlick = $(this);
            var itemSlick = listSlick.find('.service__item');
            if(listSlick.children().length > 4){
                listSlick.addClass('service__slick');
            }
            itemSlick.each(function(e){
                if(e > 3){
                    $(this).addClass('itemToggle');
                }
            });
        });
        
        var slickServicio = $('.service__slick').slick({
            autoplay: false,
            dots: true,
            arrows: true,
            infinite:  false,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 3,
            focusOnSelect: false,
            responsive: [
                {
                breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,            
                    }
                },
                {
                breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                }
            ]
        });
                                    
        $(window).on('resize', function(){
            if(($('.service__list').hasClass('unslick__mobile')) && ($(window).outerWidth() <= 600)){  
                slickServicio.slick('unslick');
                $('.unslick__mobile').parentsUntil('section').find('.service__footer').fadeIn();
            }else{
                slickServicio.slick('refresh');
                $('.unslick__mobile').parentsUntil('section').find('.service__footer').fadeOut();
            }
        });
        $(window).resize();
        
        //animacion toggle mostrar servicios
        $('.service__btn').bind('click', function(){
            var item = $(this).parent().parent().parent().find('.itemToggle');
            $(item).slideToggle();
            $(this).toggleClass('displayOn');
        });

        $('a.service--anchor').click(function(){
            var $selfAnchor = $(this).attr("href"); 
            window.location.hash = $selfAnchor;
            //animacion de scroll section
            $("html, body").animate({ scrollTop: $('section[data-anchor='+$selfAnchor+']').offset().top }, 500);
        });

    },
    equipos: function(){
        var swiper = new Swiper('.equipment--carousel .swiper-container', {
            effect: 'coverflow',
            slidesPerView: 3,
            spaceBetween: -90,
            centeredSlides: true,
            loop: true,
            coverflowEffect: {
                rotate: -80,
                stretch: -80,
                depth: 160,
                modifier: 1,
                slideShadows : false,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                992: {
                    spaceBetween: 5,
                    coverflowEffect: {
                        rotate: -30,
                        stretch: 5
                    }
                }
            }
          });
        var swiper2 = new Swiper('.equipment--block .swiper-container',{            
            centeredSlides: true,
            slidesPerView: 1,
            spaceBetween: 5,
            pagination: {
                el: '.swiper-pagination',
                dynamicBullets: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });
    },
    video: function(){
        
        function heightTumbs(){
            var $selfAlto = $('.display__item').outerHeight();
            $('.thumbs__list').css('max-height', $selfAlto);                    
        }

        function configVideo(){
            $('.item__video').attr('disablePictureInPicture', 'true').attr('controlsList', 'nodownload');
        }
        
        $('video').bind('webkitfullscreenchange mozfullscreenchange fullscreenchange', function(e) {
            var state = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen;
            var event = state ? $('.thumbs__list').fadeOut() : $('.thumbs__list').fadeIn();        
        });
                
        $(document).on('click', 'video', function(){
        if (this.paused) {                
            $(this).parent().find('.item__poster').fadeOut();
            $(this).parent().find('.item__icon').fadeOut();
        }            
        });   
          
    $('.display__list').on('init', function(event, slick){
        
        slick.$slides.each(function(index){
            //Carga diferida de videos
            var selfDisplay = $(this);
            var selfVideo = selfDisplay.find('.item__video');
            var sourceVideo = selfVideo.find('source')
            var sourceFile = sourceVideo.data('src');
            sourceVideo.attr("src", sourceFile);
            var video = sourceVideo.parent();
            
            //variables del tiempo
            var time;
            var hours;
            var minutes;
            var seconds;
        
            video.on('loadeddata', function(){
                //Duracion del video
                time = selfVideo.get(0).duration;
                hours = Math.floor( time / 3600 );  
                minutes = Math.floor((time % 3600) / 60);
                seconds = Math.round((time % 60));                
        
                //Anteponiendo un 0 a los minutos si son menos de 10 
                minutes = minutes < 10 ? '0' + minutes : minutes;
        
                //Anteponiendo un 0 a los segundos si son menos de 10 
                seconds = seconds < 10 ? '0' + seconds : seconds;
        
                if((hours === 0) && (minutes == 00)){
                    var result = minutes + ":" + seconds + ' seg';
                    selfDisplay.find('.item__poster .poster__information .time__video').text(result);
                    selfDisplay.data('duration', result);                        
                }else if((hours === 0) && (minutes > 0)){
                    var result = minutes + ":" + seconds + ' min';
                    selfDisplay.find('.item__poster .poster__information .time__video').text(result);
                    selfDisplay.data('duration', result);
                }else{
                    var result = hours + ":" + minutes + ' min';
                    selfDisplay.find('.item__poster .poster__information .time__video').text(result);
                    selfDisplay.data('duration', result);
                }
                
                //Compartiendo el dato de duracion con el slider thumbs
                var indexItem =  index;
                var textTime = selfDisplay.data('duration');    
                $('.natVideo__gallery .thumbs__item:not(.slick-cloned)').each(function(index){
                    var $selfThumb = $(this);
                    if(indexItem == index){
                        $selfThumb.find('.caption__information .time').text(textTime);
                    }
                });    
            });                                         
        });
    }).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        fade: true,
        infinite: true,
        asNavFor: '.thumbs__list',
        responsive: [
            {
                breakpoint: 992,
                settings:{
                    fade: false,
                    centerMode: true,
                    slidesToShow: 1,
                    variableWidth: true,
                    swipe: true,
                    touchMove: true,
                    swipeToSlide: true,
                    focusOnSelect: true,
                }
            },
        ]
      }).on('beforeChange', function(event, slick, currentSlide, nextSlide){
        $(slick.$slides[currentSlide]).find('.item__video').get(0).pause();
      });
      
      $('.thumbs__list').slick({
            arrows:true,
            vertical: true,
            verticalSwiping: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite:true,
            asNavFor: '.display__list',
            dots: false,
            centerMode: true,
            centerPadding: '0',
            focusOnSelect: true,
      });

        $('.display__list .item__icon').on('click', function(){
            var $self = $(this);
            var $parent = $self.parent();
            $self.fadeOut();
            $parent.find('.item__poster').fadeOut();
            $parent.find('.item__video').get(0).play();
        });        

        $(window).on('load', function() {
            configVideo();
            heightTumbs();
            $('.natVideo__gallery >.container').css({
                opacity: 1
            }, 500)                        
        });

        $(window).on('resize', function(){            
            heightTumbs();
        });

        window.addEventListener("orientationchange", function() {
            if(screen.orientation.angle == 90){
                $('.slider-nav').slick('refresh');
            }else{
                $('.slider-nav').slick('unslick');
            }
        });
    },
    pasos: function(){
        $('.natSteps .steps__slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            mobileFirst: true,
            arrows: false,
            dots: true,
            infinite: false,
            responsive: [
                {
                    breakpoint: 992,
                    settings: 'unslick'
                }
            ]
        });
    
        $(window).on('resize', function() {
            $('.natSteps .steps__slider').slick('resize');
        });
    },
    buttonAction: function(){
        //animacion toggle mostrar modulos
        $('.btn__borderless').bind('click', function(){
            var item = $(this).parentsUntil('section').find('.itemToggle');
            $(item).slideToggle();
            $(this).toggleClass('displayOn');
        });
    },
    carouselCard: function(){
        $('.natCard__blur .btn__borderless').on('click', function(){
            $(this).parent().parent().toggleClass('active');
        });   

        $('.carouselCard__list').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            infinite: true,
            centerPadding: '0',
            responsive: [
                {
                  breakpoint: 1280,
                  settings: {                    
                    slidesToShow: 3,
                    centerMode: true,
                  }
                },
                {
                    breakpoint: 992,
                    settings: {                    
                      slidesToShow: 1,
                      centerMode: true,
                      variableWidth: true,                      
                    }
                }
            ]
        }).on('beforeChange', function(event, slick, currentSlide, nextSlide){            
            $(slick.$slides[currentSlide]).find('.natCard').removeClass('active');
        });     
    },
    TabRefresh: function(){
        $('.natTabs .tabs').tabs({
            onShow: function(){
                var $self = $(this).parentsUntil('section').find('.slick-slider');
                $self.slick('refresh');
            }
        });
    },
    paso_a_paso: function(){
        $('.natStepbyStep__list').slick({            
            centerPadding: '0',
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: false,
            arrows: true,
            dots: true,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {                    
                      slidesToShow: 2,                
                    }
                },
                {
                    breakpoint: 600,
                    settings: {                    
                      slidesToShow: 1,                
                      centerMode: true,
                      variableWidth: true
                    }
                },
            ]
        });
    },
    banner_destacado: function(){
        $('.natFeatBanner__list').slick({
            arrows: false,
            dots: true,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
        });
    },
    impulso_app: function(){        
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;
        if (/android/i.test(userAgent)) {            
            console.log("Android");
            $('.btn__app--ios').parent().remove();
        }        
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            console.log("Ios");
            $('.btn__app--android').parent().remove();
        }

    }
}
$(function () {
    MyApp.bannerEvo();
    MyApp.bannerEvo2();
    // MyApp.carruselPlanes();
    MyApp.contactanos();
    MyApp.servicio();
    MyApp.equipos();
    MyApp.video();
    MyApp.pasos();
    MyApp.buttonAction();
    MyApp.carouselCard();
    MyApp.TabRefresh();
    MyApp.paso_a_paso();
    MyApp.banner_destacado();
    MyApp.impulso_app();
});

